export default __webpack_public_path__ + "static/ukrainian-code-42f46f415b3e0ec61de955cc10eda731.svg";